import { PollCampaignLeaderProps } from "../../../store/types/auth_svc";


export const poll_leaders_getPlace = (plc:PollCampaignLeaderProps[]):PollCampaignLeaderProps[] => {
    let place = 1;
    let winnings = 0;
    let tracker = 0;
    let updated_plcs:PollCampaignLeaderProps[] = []
    plc.sort((a,b) => b.winnings - a.winnings).map(l => {
        if(l.winnings < winnings){
            place += tracker
            tracker = 0
        }
        tracker += 1
        winnings = l.winnings
        updated_plcs.push({ ...l, place })
    })
    return updated_plcs
}